module.exports = __webpack_public_path__ + "static/media/AgreementFeature1.66c78dcc.avif";